

import { Box, Paper, Typography } from '@mui/material';
import { ProviderButtons } from './ProviderButtons';
import { ClientSafeProvider } from 'next-auth/react';

interface SignInComponentProps {
  providers: Record<string, ClientSafeProvider> | null;
  loading: string | null;
  error?: string | null;
  onSignIn: (providerId: string) => void;
}

export function SignInComponent({ providers, loading, error, onSignIn }: SignInComponentProps) {
  return (
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={2}
        sx={{
          padding: 4,
          width: '100%',
          borderRadius: 2
        }}
      >
        <Typography component="h1" variant="h4" align="center" fontWeight="600" gutterBottom>
          Sign In
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 4 }}>
          Choose your sign-in method
        </Typography>
        {error && (
          <Box
            sx={{
              p: 2,
              mb: 3,
              backgroundColor: 'error.light',
              borderRadius: 1,
              color: 'error.contrastText'
            }}
          >
            <Typography align="center" variant="body2">
              Authentication failed: {error}
            </Typography>
          </Box>
        )}
        {providers && (
          <ProviderButtons providers={providers} loading={loading} onSignIn={onSignIn} />
        )}
      </Paper>
    </Box>
  );
}
